import { toast } from '@/clientWeb/components/ui/toast-utils'
import { playNotificationSound } from '@vc/utils/notificationSound'
import { useMeetingPreferencesStore } from '../store/meeting-preferences.store'

/**
 * One in-call notice — the toast the meeting already uses for recording and
 * host requests, behind the in-meeting "Notifications" / "Notification sounds"
 * switches.
 *
 * `personal` is for what happens TO you — the host muted you, made you a
 * co-host, closed your breakout room. Those show even with notifications off,
 * like the recording notice: the switch is for the room's comings and goings,
 * not for hiding why your own mic just went off.
 */
export function meetingAlert(
  title: string,
  opts: { description?: string; personal?: boolean; sound?: boolean } = {},
): void {
  const prefs = useMeetingPreferencesStore.getState()
  if (!opts.personal && !prefs.inMeetingNotifications) return
  toast.info({ title, description: opts.description })
  if (opts.sound && prefs.inMeetingNotificationSounds) playNotificationSound()
}
